module.exports = __webpack_public_path__ + "img/slider_text_b1.2565fbd.cbb7e125.png";